import { render, staticRenderFns } from "./TopLocationsTable.vue?vue&type=template&id=fbd0159e&scoped=true&"
import script from "./TopLocationsTable.vue?vue&type=script&lang=js&"
export * from "./TopLocationsTable.vue?vue&type=script&lang=js&"
import style0 from "./TopLocationsTable.vue?vue&type=style&index=0&id=fbd0159e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd0159e",
  null
  
)

export default component.exports